import { render, staticRenderFns } from "./PreguntasFrecuentes.vue?vue&type=template&id=fb23df30&"
import script from "./PreguntasFrecuentes.vue?vue&type=script&lang=js&"
export * from "./PreguntasFrecuentes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports